import React from 'react';
import LocationMap from '../google-map/LocationMap';
import { EMPTY_PLACEHOLDER } from '../../utils/Constants';

const LocationViewTab = (props) => {
  const { location } = props;

  const displayTimeZone =
    location?.locationType === 'EXTERNAL'
      ? location?.timezone
      : location?.timeZone || EMPTY_PLACEHOLDER;

  return (
    <>
      <div className='row mt-4 mb-2'>
        <div className='col-md-12'>
          <div className='details-label'>Address Line 1</div>
          <div className='details-value'>{location?.addressLine1}</div>
        </div>
      </div>
      <div className='row  mt-4 mb-2'>
        <div className='col-md-12'>
          <div className='details-label'>Address Line 2</div>
          <div className='details-value'>
            {location?.addressLine2 ? location?.addressLine2 : EMPTY_PLACEHOLDER}
          </div>
        </div>
      </div>
      <div className='row mt-4 mb-2'>
        <div className='col-md-6'>
          <div className='details-label'>Country</div>
          <div className='details-value'>{location?.country}</div>
        </div>
        <div className='col-md-6'>
          <div className='details-label'>State</div>
          <div className='details-value'>{location?.state}</div>
        </div>
      </div>
      <div className='row mt-4 mb-2'>
        <div className='col-md-6'>
          <div className='details-label'>Postal Code</div>
          <div className='details-value'>
            {location?.postalCode ? location?.postalCode : EMPTY_PLACEHOLDER}
          </div>
        </div>
        <div className='col-md-6'>
          <div className='details-label'>City</div>
          <div className='details-value'>{location?.city}</div>
        </div>
      </div>
      <div className='row mt-4 mb-2'>
        <div className='col-md-6'>
          <div className='details-label'>Latitude</div>
          <div className='details-value'>
            {location?.latitude ? location?.latitude : EMPTY_PLACEHOLDER}
          </div>
        </div>
        <div className='col-md-6'>
          <div className='details-label'>Longitude</div>
          <div className='details-value'>
            {location?.longitude ? location?.longitude : EMPTY_PLACEHOLDER}
          </div>
        </div>
      </div>
      <div className='row mt-4 mb-2'>
        <div className='col-md-6'>
          <div className='details-label'>Area</div>
          <div className='details-value'>{location?.area || EMPTY_PLACEHOLDER}</div>
        </div>
        <div className='col-md-6'>
          <div className='details-label'>Time Zone</div>
          <div className='details-value'>{displayTimeZone}</div>
        </div>
      </div>
      <div className='row mt-4'>
        <div className='col-md-7'>
          <div className='details-label'>Google Maps</div>
          <div className='details-value'>
            <LocationMap lat={location?.latitude} lng={location?.longitude} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationViewTab;
